import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { ClassInvoice } from '@models/invoice';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSafeStorage, createSizePartialize } from '@utils/localStorage';

const PAGE_SIZE = 20;

interface ClassInvoicesContainer {
  contents: ClassInvoice[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

interface ClassInvoicesStoreProps {
  searchResultContainer: ClassInvoicesContainer;
  searchQuery: SearchPagenateQuery;
  searchKeyword?: string;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: () => void;
  setClassInvoicesContainer: (result: PagenatedResponse<ClassInvoice>) => void;
}

export const useClassInvoicesStore = create(
  persist<ClassInvoicesStoreProps>(
    (set) => ({
      searchResultContainer: {
        contents: [] as ClassInvoice[],
        total: 0,
        page: 0,
        size: 0,
        hasNext: false,
      },
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
        type: 'all',
      },
      setStartDate: (date: string | null) => {
        set((state) => {
          return { ...state, searchQuery: { ...state.searchQuery, startDate: date } };
        });
      },
      setEndDate: (date: string | null) => {
        set((state) => {
          return { ...state, searchQuery: { ...state.searchQuery, endDate: date } };
        });
      },
      searchKeyword: undefined,
      setClassInvoicesContainer: (result) => {
        set((state) => {
          // 메모리 효율성을 위해 실제 데이터만 저장
          const newValue = {
            ...state.searchResultContainer,
            ...result,
            contents: result?.contents || [],
          };
          return { ...state, searchResultContainer: newValue };
        });
      },
      setSearchKeyword: (keyword: string) => {
        set((state) => {
          return {
            ...state,
            searchKeyword: keyword,
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      updateSearchQuery: (query: { [key: string]: any }) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, ...query },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      resetSearchQuery: () => {
        set({
          searchQuery: {
            page: 0,
            size: PAGE_SIZE,
            type: 'all',
          },
        });
      },
    }),
    {
      name: 'igogo-admin-class-invoices',
      storage: createSafeStorage(),
      partialize: createSizePartialize<ClassInvoicesStoreProps>(100),
    },
  ),
);
